import { render, staticRenderFns } from "./addressselector.vue?vue&type=template&id=4cb3f41a"
import script from "./addressselector.vue?vue&type=script&lang=js"
export * from "./addressselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports